import { IAccountingBasisState } from './accounting-basis-state.interface';
import { ICurrencyState } from './currency-state.interface';
import { IFinancialLineItemState } from './financial-line-item-state.interface';
import { ILegalFormState } from './legal-form-state.interface';
import { ITranslationsState } from './translations-state.interface';

export interface SettingsFeatureState {
    accountingBasis?: IAccountingBasisState;
    legalForm?: ILegalFormState;
    financialLineItem?: IFinancialLineItemState;
    currency: ICurrencyState;
    translations?: ITranslationsState;
}
